import { HttpErrorResponse } from "@angular/common/http";

export type ErrorClassification = 'NetworkConnectionIssue' | 'ItemNotFound' | 'UnsupportedVersion' | 'Terminal'

export function classifyError(error: any): ErrorClassification {
  if (error instanceof HttpErrorResponse)
  {
    switch (error.status)
    {
      case 0: return 'NetworkConnectionIssue';
      case 404: return 'ItemNotFound';
      case 422: return 'UnsupportedVersion';
      default: return 'Terminal';
    }
  }

  return 'Terminal';
}

function tagTerminalError(): void {
  /* TODO:
  this.hotjarService.addTag('terminal-error');
  this.heapService.addEvent('Terminal Error');
  */
}

function tagConnectivityIssues(): void {
  /* TODO:
  this.hotjarService.addTag('connectivity-issues');
  this.heapService.addEvent('Connectivity Issues');
  */
}

export function reportError(error: any): void {
  switch (classifyError(error))
  {
    case 'NetworkConnectionIssue':
      tagConnectivityIssues();
      break;
    case 'Terminal':
      console.error('Terminal error:', error);
      tagTerminalError();
      break;
  }
}